import React from 'react'
import { Link } from 'react-router-dom'
import JsonLd from './jsonLd'

import logoCalendar from '../images/calendar.svg'
import logoLocation from '../images/location.svg'
import logoPhone from '../images/phone.svg'

import './footer.scss'

const Footer = () => (
  <div className="footer">
    <div className="footer__container">
      <div className="footer__container-item">
        <div className="item__content">
          <img
            src={logoCalendar}
            alt="Ouverture cabinet psychologue Montpellier, montpellier psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne quartier les arceaux, cabinet de psychologie à Montpellier quartier les arceux, psychologue clinicienne"
          />
        </div>
        <p>Entretiens sur rendez-vous</p>
        <ul className="u-list-style">
          <li>
            Lundi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
          <li>
            Mardi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
          <li>
            Mercredi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
          <li>
            Jeudi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
        </ul>
      </div>
      <div className="footer__container-item">
        <div className="item__content">
          <img
            src={logoLocation}
            alt="adresse cabinet psychologue montpellier, Montpellier psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne clinicienne à Montpellier quartier les arceaux, cabinet de psychologie clinicienne à Montpellier quartier les arceaux, psychologue clinicienne"
          />
        </div>
        <address
          itemProp="address"
          itemScope
          itemType="http://schema.org/PostalAddress"
        >
          <span itemProp="streetAddress">300 Rue Auguste Broussonnet </span>
          <br />
          <span itemProp="postalCode">34090</span>
          <span itemProp="addressLocality"> Montpellier</span> <br />
          Arrêt de tram<br /> Place Albert 1er Saint Charles
          <Link
            className="footer__container-link"
            target="_blank"
            to="https://tam.cartographie.pro"
          >
            Plan d’accès{' '}
          </Link>
        </address>
      </div>
      <div className="footer__container-item">
        <div className="item__content">
          <img
            src={logoPhone}
            alt="contact psychologue montpellier, montpellier psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne à Montpellier quartier les arceaux, cabinet de psychologie à Montpellier quartier les arceaux, psychologue clinicienne"
          />
        </div>
        <a
          className="footer__container-link"
          href="tel:+33674318234"
          itemProp="telephone"
        >
          Tél: 06.74.31.82.34{' '}
        </a>
        <a
          className="footer__container-link footer__container-link--ellipsis"
          href="mailto:psychologue.morgane.laroche@gmail.com"
          itemProp="email"
        >
          psychologue.morgane.laroche@gmail.com
        </a>
      </div>
    </div>
    <JsonLd />
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/modules/footer.js